module.exports = __webpack_public_path__ + "static/img/MRT-Ultra-1.dbe2527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/MRT-Ultra-1.jpg
// module id = 8Em3
// module chunks = 1